import { render } from "./FootBar.vue?vue&type=template&id=0c568e4c&ts=true"
import script from "./FootBar.vue?vue&type=script&lang=ts"
export * from "./FootBar.vue?vue&type=script&lang=ts"

import "./FootBar.vue?vue&type=style&index=0&id=0c568e4c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__